import { createContext, useState, useEffect } from "react";
import { domain } from "../consts";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    isAuthenticated: false,
    user: null,
    isLoading: true,
  });
  const [update, setUpdate] = useState(false);
  useEffect(() => {
    fetchUserInfo();
  }, [update]);

  const fetchUserInfo = async () => {
    try {
      const response = await fetch(`${domain}/me`, {
        credentials: "include",
      });
      if (!response.ok) {
        setAuth({ ...auth, isLoading: false });
        return;
      }
      const user = await response.json();
      setAuth({ ...auth, isLoading: false });
      if (!user?.id) return;
      setAuth({ isAuthenticated: true, user: user, isLoading: false });
    } catch (error) {
      setAuth({ ...auth, isLoading: false });
      // console.error("Error fetching user info:", error);
    }
  };

  const logout = async () => {
    try {
      const response = await fetch(`${domain}/logout`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        setAuth({
          isAuthenticated: false,
          user: null,
        });
        location.assign("/auth");
      } else {
        console.error("Logout failed with status:", response.status);
      }
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  return (
    <AuthContext.Provider value={{ auth, setAuth, setUpdate, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
